export default __webpack_public_path__ + "static/media/gallery02.931097bf.jpg";